/* global document */

/**
 * Loads the TrustedForm script into the page.  This function has been adapted from the official script provided by
 * ActiveProspect.
 * NOTE THAT THIS FUNCTION DOES DOM MANIPULATION AND MUST BE CALLED FROM THE useEffect or useLayoutEffect HOOK TO AVOID
 * GASTSBY BUILD ERRORS!
 */
const dangerouslyLoadTrustedFormScript = (formSelector = '') => {
  if (typeof document === 'undefined') {
    return
  }
  const field = encodeURI('xxTrustedFormCertUrl')
  const provideReferrer = encodeURI(false)
  const invertFieldSensitivity = false
  const tf = document.createElement('script')
  tf.type = 'text/javascript'
  tf.async = true
  const time = `${new Date().getTime()}${Math.random()}`
  const protocol = document.location.protocol === 'https:' ? 'https' : 'http'
  tf.src = `${protocol}://api.trustedform.com/trustedform.js?provide_referrer=${provideReferrer}&field=${field}&l=${time}&invert_field_sensitivity=${invertFieldSensitivity}`
  // Add form_selector to the script source if a specific selector is provided
  if (formSelector) {
    tf.src += `&form_selector=${encodeURIComponent(formSelector)}`;
  }
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(tf, s)
}

/**
 * Looks for Trusted Form fields in the provided DOM node and returns their values.
 * Since the Trusted Form fields get loaded asynchronously after the form has mounted, FinalForm is unaware of them.
 * This function should be called on form submit get the values which should then be merged into the form data that is
 * sent to TCPA and Emily.
 * @param form - DOM node of the form the fields will be added to, e.g. formRef.current
 */
const getTrustedFormFieldValues = (form) =>
  new Promise((resolve, reject) => {
    const tokenField = form.querySelector('[name="xxTrustedFormToken"]')
    const certField = form.querySelector('[name="xxTrustedFormCertUrl"]')
    if (tokenField.value && certField.value) {
      resolve({
        xxTrustedFormToken: tokenField.value,
        xxTrustedFormCertUrl: certField.value,
      })
    } else {
      reject()
    }
  })

module.exports = {
  dangerouslyLoadTrustedFormScript,
  getTrustedFormFieldValues,
}
